export default __webpack_public_path__ + "static/media/t2p_logo.762132ae.svg";